import React from 'react';
import {
  Button,
  ButtonType,
  Row
} from 'syngenta-digital-cropwise-react-ui-kit';

import ChevronLeftIcon from 'assets/chevron_left.svg';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';
import { useFormikContext } from 'formik';
import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';

interface FooterProps {
  step: number;
  handleBack: () => void;
  handleNext: () => void;
}

const Footer: React.FC<FooterProps> = ({ step, handleBack, handleNext }) => {
  const { submitForm } = useFormikContext<Product>();

  const onNext = () => {
    if (step === 0) {
      handleNext();
    } else {
      submitForm();
    }
  };

  return (
    <Row justify="space-between">
      <Button
        type={ButtonType.outline}
        className="px-3"
        onClick={handleBack}
        aria-label="Back"
        size="large"
      >
        <Row>
          <img className="mr-1" alt="plus" src={ChevronLeftIcon} />
          <span>Back</span>
        </Row>
      </Button>
      <Button
        type={ButtonType.primary}
        ghost={step === 0}
        onClick={onNext}
        size="large"
      >
        {step === 0
          ? LayoutStrings.products.selectProduct
          : LayoutStrings.products.tankInfo.saveCarrier}
      </Button>
    </Row>
  );
};

export default Footer;
